<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>

<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
      <li class="breadcrumb-item active">Add-on Catalog</li>
    </ol>
  </nav>
</div>

<div class="container mt-2 themeTblReso">
  <div class="assignFilterBar">
    <div class="filterItem">
      <select class="form-control formstyle" [ngModel]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
        <option value="0">Please select company</option>
        <ng-container *ngFor="let userObj of getCompanyobj">
          <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
            {{userObj.customer_company_name}}
          </option>
        </ng-container>
      </select>
    </div>
    <div class="filterItem filterSearch">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1">
            <i class="fa fa-search text-white" aria-hidden="true"></i>
          </span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" [(ngModel)]="text"
          [readonly]="catalogData == null || catalogData.length == 0">
      </div>
    </div>
    <div class="filterAction">
      <input type="button" value="Reset" class="custbtn-outline" (click)="resetFilters()" />
    </div>
  </div>
  <div class="tblPrt">
  <p *ngIf="independentNote" class="text-center mt-2">{{independentNote}}</p>
  <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
    <tr>
      <th (click)="setOrder('addon_sort')" style="cursor: pointer;">Sort <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
      <th (click)="setOrder('bundle_name')" style="cursor: pointer;">Add-on Name <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
      <th (click)="setOrder('monthly_price')" style="cursor: pointer;">Monthly <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
      <th (click)="setOrder('yearly_price')" style="cursor: pointer;">Yearly <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
      <th (click)="setOrder('credits_per_dollar')" style="cursor: pointer;">Cr / $1 <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
      <th>Basic</th>
      <th>Professional</th>
      <th *ngIf="isEdit" width="80">Action</th>
    </tr>
    <tr *ngFor="let obj of catalogData | filter:text | orderBy: order:reverse:'case-insensitive' | paginate:{itemsPerPage:10,currentPage:cp }">
      <td>{{obj.addon_sort}}</td>
      <td>{{obj.bundle_name}}</td>
      <td>${{obj.monthly_price}}</td>
      <td>${{obj.yearly_price}}</td>
      <td>{{obj.credits_per_dollar}}</td>
      <td>{{obj.allow_basic ? 'Yes' : 'No'}}</td>
      <td>{{obj.allow_professional ? 'Yes' : 'No'}}</td>
      <td *ngIf="isEdit">
        <div class="actBtn wit-80">
          <i class="fa fa-edit mr-1 cursor" (click)="editAddon(obj.bundle_id)" placement="bottom" ngbTooltip="Edit"></i>
          <mat-slide-toggle [checked]="obj.is_addon_sellable" class="my-slider cursor"
            (click)="updateSellableStatus(obj.bundle_id, obj.is_addon_sellable)">
          </mat-slide-toggle>
        </div>
      </td>
    </tr>
  </table>
  <pagination-controls *ngIf="catalogData && catalogData.length > 10" class="my-pagination mt-2" (pageChange)="cp=$event"></pagination-controls>
  <div *ngIf="!independentNote && (catalogData | filter:text ).length === 0" style="text-align: center">
    <p>No Result Available</p>
  </div>
</div>
</div>
